import { schema } from 'normalizr';
import isNil from 'lodash/isNil';
import has from 'lodash/has';

import {
  SCHEMA_TYPE_SOURCES,
  SCHEMA_TYPE_DATA_SETS,
  SCHEMA_TYPE_SINKS,
} from '../constants/schemaTypes';

import userSchema from './user';
import orgSchema from './org';
import { apiKeySchema } from './apiKey';
import vendorEndpointSchema from './vendorEndpoint';
import dataMapSchema from './dataMap';
import credentialSchema from './credential';
import { isDetectedDataset } from '../lib/ResourceUtils';

const dataSourceSchema = new schema.Entity(
  SCHEMA_TYPE_SOURCES,
  {
    owner: userSchema,
    org: orgSchema,
    vendor_endpoint: vendorEndpointSchema,
    api_keys: [apiKeySchema],
  },
  {
    processStrategy: (value) => {
      let returnValue = { ...value };
      if (has(value, 'vendor') && !isNil(value.vendor)) {
        returnValue['vendor_id'] = value.vendor.id;
      }
      if (!has(value, 'org') && has(value, 'org_id')) {
        returnValue['org'] = value.org_id;
      }

      if (!has(value, 'owner') && has(value, 'owner_id')) {
        returnValue['owner'] = value.owner_id;
      }

      return returnValue;
    },
  },
);

const dataSinkSchema = new schema.Entity(
  SCHEMA_TYPE_SINKS,
  {
    owner: userSchema,
    org: orgSchema,
    vendor_endpoint: vendorEndpointSchema,
    data_map: dataMapSchema,
    data_credentials: credentialSchema,
  },
  {
    processStrategy: (value) => {
      let returnValue = { ...value };
      if (has(value, 'vendor') && !isNil(value.vendor)) {
        returnValue['vendor_id'] = value.vendor.id;
      }
      if (!has(value, 'org') && has(value, 'org_id')) {
        returnValue['org'] = value.org_id;
      }

      if (!has(value, 'owner') && has(value, 'owner_id')) {
        returnValue['owner'] = value.owner_id;
      }

      return returnValue;
    },
  },
);

const dataSetSchema = new schema.Entity(
  SCHEMA_TYPE_DATA_SETS,
  {
    owner: userSchema,
    org: orgSchema,
    data_source: dataSourceSchema,
    data_sinks: [dataSinkSchema],
    api_keys: [apiKeySchema],
  },
  {
    processStrategy: (value) => {
      let returnValue = { ...value };

      if (!has(value, 'org') && has(value, 'org_id')) {
        returnValue['org'] = value.org_id;
      }

      if (!has(value, 'owner') && has(value, 'owner_id')) {
        returnValue['owner'] = value.owner_id;
      }
      returnValue['is_detected'] = isDetectedDataset(value);

      return returnValue;
    },
  },
);

// @DOC
//  Create a separate schema instance for shared datasets, keep normalize to the same entity type (SCHEMA_TYPE_DATA_SETS)
//  Now shared datasets get the isShared flag to distinguish their origin.
export const sharedDataSetSchema = new schema.Entity(
  SCHEMA_TYPE_DATA_SETS,
  {
    owner: userSchema,
    org: orgSchema,
    data_source: dataSourceSchema,
    data_sinks: [dataSinkSchema],
    api_keys: [apiKeySchema],
  },
  {
    processStrategy: (value) => {
      let returnValue = { ...value };

      if (!has(value, 'org') && has(value, 'org_id')) {
        returnValue['org'] = value.org_id;
      }

      if (!has(value, 'owner') && has(value, 'owner_id')) {
        returnValue['owner'] = value.owner_id;
      }
      returnValue['is_detected'] = isDetectedDataset(value);

      returnValue['isShared'] = true;

      return returnValue;
    },
  },
);

export default dataSetSchema;
